import { useCallback } from 'react';

interface MoveToCurrentSlideProps {
    slides: React.RefObject<Map<number, HTMLDivElement>>;

    currentSlideIndex: number;

    listContainerRef: React.RefObject<HTMLDivElement>;

    isDragging: boolean;

    setTranslateX: React.Dispatch<React.SetStateAction<number>>;
}

export const useMoveToCurrentSlide = function () {
    return useCallback(
        ({ slides, currentSlideIndex, listContainerRef, isDragging, setTranslateX }: MoveToCurrentSlideProps) => {
            // Получаем все ключи слайдов
            const slidesKeys = Array.from(slides.current?.keys() || []);

            // Получаем текущий слайд
            const currentElement = slides.current?.get(currentSlideIndex);

            // Получаем последний слайд
            const lastElementKey = slidesKeys[slidesKeys.length - 1];

            if (
                currentElement &&
                typeof lastElementKey === 'number' &&
                typeof currentSlideIndex === 'number' &&
                listContainerRef.current &&
                !isDragging
            ) {
                const lastElement = slides.current?.get(lastElementKey);
                const moveToCurrentElement = currentElement.offsetLeft;

                if (!lastElement) {
                    return setTranslateX(moveToCurrentElement * -1);
                }

                // Если последний элемент помещается изначально, то скролл не требуется
                if (listContainerRef.current.offsetWidth >= lastElement.offsetLeft + lastElement.offsetWidth) {
                    return setTranslateX(moveToCurrentElement * -1);
                }

                // Скроллим на максимально доступное расстояние (к текущему слайду и концу)
                return setTranslateX(
                    Math.max(
                        listContainerRef.current.offsetWidth - (lastElement.offsetLeft + lastElement.offsetWidth),
                        moveToCurrentElement * -1,
                    ),
                );
            }
        },
        [],
    );
};
